import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.kiosk.character');
import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-kiosk-character',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.kiosk.character/view.scss */
/* src/app/portal.kiosk.character/view.scss: no such file or directory */`],
})
export class PortalKioskCharacterComponent implements OnInit {

    constructor(@Inject( Service)         public service: Service,@Inject( Router)         private router: Router,    ) { }
    public cardW = 716;
    public gap = 144;
    public peek = 182;
    public currentIndex = 0;
    public selectIndex = null;

    get trackTranslate(): string {
        const step = this.cardW + this.gap;
        return `translateX(-${this.currentIndex * step}px)`;
    }

    public slides = [
        { title: '복숭아 캐릭터', img: '/assets/character/peach.png', param: 'peach' },
        { title: '세종대왕', img: '/assets/character/sejong.png', param: 'king' },
        { title: '한글 캐릭터', img: '/assets/character/hangle.png', param: 'hangeul' }
    ];

    public async ngOnInit() {
    }

    public select(i) {
        this.selectIndex = i;
        this.service.render();
    }

    public go(i: number) {
        this.currentIndex = i;
    }

    // 끝에서 멈추는 버전
    // public next() { this.currentIndex = Math.min(this.currentIndex + 1, this.slides.length - 1); }
    // public prev() { this.currentIndex = Math.max(this.currentIndex - 1, 0); }

    // 계속 도는 버전
    public next() { this.currentIndex = (this.currentIndex + 1) % this.slides.length; }
    public prev() { this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length; }

}

export default PortalKioskCharacterComponent;